// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/value-proposition/value-proposition.component.scss
// module id = 552
// module chunks = 0